import React from "react";


const diasSemana = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

const ModalNoEditar = ({ open, onClose, corteEdicion }) => {
  if (!open) return null;
  const dayLabel = diasSemana[corteEdicion?.day ?? 3] || "miércoles";
  const horaLabel = corteEdicion?.time || "10:00";
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 animate-fadein" style={{ backdropFilter: 'blur(6px)', backgroundColor: 'rgba(0,0,0,0.08)' }}>
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md text-center transform transition-all duration-300 animate-fadeinModal border border-red-200">
        <div className="flex flex-col items-center mb-4">
          <span className="inline-block mb-2">
            <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><circle cx="24" cy="24" r="22" fill="#FEE2E2" stroke="#F87171" strokeWidth="2" /><path d="M24 14v12" stroke="#DC2626" strokeWidth="3" strokeLinecap="round" /><circle cx="24" cy="32" r="2.5" fill="#DC2626" /></svg>
          </span>
          <h3 className="text-2xl font-bold text-red-700">Edición no permitida</h3>
        </div>
        <p className="mb-6 text-slate-700 text-base">Ya no puedes modificar el menú seleccionado para este día.<br />Solo es posible editar hasta el día <span className="font-semibold text-blue-700">{dayLabel}</span> a las <span className="font-semibold text-blue-700">{horaLabel}</span> de cada semana.</p>
        <button className="px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold shadow-lg hover:bg-blue-700 transition" onClick={onClose}>Cerrar</button>
        <div className="mt-4 text-slate-400 text-sm flex items-center justify-center gap-2">
          <span role="img" aria-label="reloj">⏰</span>
          <span>Intenta la próxima semana para modificar tu menú.</span>
        </div>
      </div>
      <style>{`
        @keyframes fadein { from { opacity: 0; } to { opacity: 1; } }
        .animate-fadein { animation: fadein 0.3s; }
        @keyframes fadeinModal { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-fadeinModal { animation: fadeinModal 0.3s; }
      `}</style>
    </div>
  );
};

export default ModalNoEditar;
